import React from "react";
import { Link, graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types"
// import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Img } from 'gatsby-image';
import { documentToHtmlString} from '@contentful/rich-text-html-renderer'
// const document = {
//   nodeType: 'document',
// };

const Bold = ({ children }) => <span className="bold">{children}</span>
const Text = ({ children }) => <p className="align-center">{children}</p>

const options = {
  renderNode: {
    [INLINES.ASSET_HYPERLINK]: node => {
      return `<img class='custom-asset' src="${
              node.data.target.fields.file['fr-FR'].url
            }"/>`
    },
    [INLINES.EMBEDDED_ENTRY]: node => {
      return `<span class='custom-entry'>${
              node.data.target.fields.name['fr-FR']
            }</span>`
    },
    [INLINES.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
   
  },
  renderMark: {
    [INLINES.BOLD]: text => <Bold>{text}</Bold>,
  },
}
  
// const options = {
//   renderMark: {
//     [MARKS.BOLD]: text => `<b>${text}</b>`,
//   },
//   renderNode: {
//     [BLOCKS.PARAGRAPH]: (node, children) => (
//       <p className="p">{children}</p>
//     ),
//   },
// }

const BlogPost = ({ data }) => {
  const { author, title, body, image, tags } = data.contentfulBlogPost;

  console.log(data)
  return (
    <Layout>
      <SEO title={title} />
      <div className="blogpost">
        <h1>{title}</h1>
         <div>
          {image.map(images =>
            <img alt={title} src={images.file.url} />
          )}
        </div> 
        <div className="tags">
          {tags.map(tag => (
            <span className="tag" key={tag}>
              {tag}
            </span>
          ))}
        </div>
        <p className="body-text"
          dangerouslySetInnerHTML={{
            __html: documentToHtmlString(body.json)
          }}
        >
          {/* {body.json} */}
        </p>
        <p className="author">
            {author.map((authors) =>
              <>
                <i>Author</i><br />
                <b>{authors.name}</b> | <span>{authors.bio}</span>. 
              </>
            )}
        </p>
        <Link to="/posts">View more posts</Link>
        <Link to="/">Back to Home</Link>
      </div>
    </Layout>
  );
};

export default BlogPost;

export const pageQuery = graphql`
  query($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      author {
        id
        name
        bio
      }
      slug
      body {
        json
      }
      image {
        file {
          url
        }
      }
      tags
    }
  }
`;